import { render, staticRenderFns } from "./joinDialog.vue?vue&type=template&id=3458d96f&scoped=true"
import script from "./joinDialog.vue?vue&type=script&lang=js"
export * from "./joinDialog.vue?vue&type=script&lang=js"
import style0 from "./joinDialog.vue?vue&type=style&index=0&id=3458d96f&prod&lang=scss"
import style1 from "./joinDialog.vue?vue&type=style&index=1&id=3458d96f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3458d96f",
  null
  
)

export default component.exports